import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_CUSTOMER,
  DELETE_CUSTOMER,
  GET_CUSTOMERS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_STATUS
} from "./actionTypes";

import {
  addCustomerFail,
  addCustomerSuccess,
  deleteCustomerFail,
  deleteCustomerSuccess,
  getCustomersFail,
  getCustomersSuccess,
  setState,
  updateCustomerFail,
  updateCustomerSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { customers, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchCustomers({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, customers, params.toString());
    yield put(setState(false));
    yield put(getCustomersSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getCustomersFail(error));
  }
}

function* updateCustomer({ payload: customerObj }) {
  try {
    const { id, ...rest } = customerObj;
    yield call(patchApiCall, `${customers}/${id}`, rest);
    const response = yield call(getTable, `${customers}/${customerObj.id}`);
    yield put(updateCustomerSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateCustomerFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateCustomerStatus({ payload: customerObj }) {
  try {
    const { id } = customerObj;
    yield call(patchApiCall, `${customers}/${updateStatus}/${id}`, { recordStatus: customerObj.recordStatus });
    const response = yield call(getTable, `${customers}/${customerObj.id}`);
    yield put(updateCustomerSuccess(response));
  } catch (error) {
    yield put(updateCustomerFail(error));
  }
}

function* deleteCustomer({ payload: customerObj }) {
  try {
    yield call(deleteApiCall, `${customers}/${customerObj.id}`);
    yield put(deleteCustomerSuccess(customerObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteCustomerFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingCustomer({ payload: customer }) {
  try {
    const response = yield call(postApiCall, customers, customer);
    const newCustomer = yield call(getTable, `${customers}/${response.id}`);
    yield put(addCustomerSuccess(newCustomer));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addCustomerFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* customersSaga() {
  yield takeEvery(GET_CUSTOMERS, fetchCustomers);
  yield takeEvery(ADD_NEW_CUSTOMER, postingCustomer);
  yield takeEvery(UPDATE_CUSTOMER, updateCustomer);
  yield takeEvery(UPDATE_CUSTOMER_STATUS, updateCustomerStatus);
  yield takeEvery(DELETE_CUSTOMER, deleteCustomer);
}

export default customersSaga;
